const { DEFAULT_FIVERR_LOCALE } = require('@fiverr-private/localization');
const { isGigPaused } = require('../../gigStatus');
const { GOATS_GIG_PAGE_STICKY_CTA } = require('../experimentsEnum');
const { getVariation, isAllocated } = require('..');

const ALLOWED_CURRENCIES = ['USD'];

/**
 * Returns whether or not the given context is excluded from the experiment.
 * @param {boolean} isMobile - from RequestContext
 * @param {string} organizationId - from RequestContext
 * @param {string} locale - from RequestContext
 * @param {string} currency - from RequestContext
 * @returns Whether or not the given context is excluded from the experiment
 */
const isExcludedFromMobileStickyCtaExperiment = ({ isMobile, organizationId, locale, currency }) =>
    !isMobile || !!organizationId || locale !== DEFAULT_FIVERR_LOCALE || !ALLOWED_CURRENCIES.includes(currency);

/**
 * Returns whether or not to render the mobile sticky cta section.
 * @param {object} context the request context
 * @param {number[]} variations the experiment variations to render
 * @returns {boolean} Whether or not to render the mobile sticky cta section
 */
const inMobileStickyExperience = ({ context, general, variations }) => {
    const { abTests } = context;
    const { gigStatus, traffiqed, isLimitedEdition, isOnVacation } = general;
    const isPaused = isGigPaused(gigStatus, traffiqed);

    if (isLimitedEdition || isOnVacation || isPaused) {
        return false;
    }

    if (isExcludedFromMobileStickyCtaExperiment(context)) {
        return false;
    }

    if (!isAllocated(GOATS_GIG_PAGE_STICKY_CTA, abTests)) {
        return false;
    }

    return variations.includes(getVariation(GOATS_GIG_PAGE_STICKY_CTA, abTests));
};

module.exports = {
    ALLOWED_CURRENCIES,
    isExcludedFromMobileStickyCtaExperiment,
    inMobileStickyExperience
};
